import { lazy } from "react";

export type {
    Quarter,
    Quarters,
    QuarterControlProps,
} from "./QuarterControl.component";

export const QuarterControl = lazy(() => import("./QuarterControl.component"));
